import * as countries from 'country.json';
import { Country } from 'models/country';

// NOTE: A copy of this files exists in the frontend and backend.
//       Make sure to keep them in sync.

export const countryFromCode = (countryCode?: string) => {
    const country = Object.values(countries).find((country) => country.alpha2Code === countryCode);
    return country;
};

export const formatOrganizationNumber = (organizationNumber: string, countryCode: string) => {
    const country = Object.values(countries).find((country) => country.alpha2Code === countryCode);
    if (
        country?.organizationNumberPattern &&
        country?.organizationNumberPattern !== country?.organizationNumberFormat
    ) {
        return organizationNumber.replace(new RegExp(country.organizationNumberPattern), '$1-$2');
    }
    return organizationNumber;
};

export const getEnabledCountries = () => {
    const scanCountries = Object.values(countries).filter((country: Country) => {
        return (
            country.alpha2Code === 'DK' || // Denmark
            country.alpha2Code === 'FI' || // Finland
            country.alpha2Code === 'NO' || // Norway
            country.alpha2Code === 'SE' || // Sweden
            country.alpha2Code === 'IS' || // Iceland
            country.alpha2Code === 'EE' // Estonia
        );
    });
    return scanCountries;
};
